export const ProjectMenuIcon = ({ width = 16, height = 16, color = "#1D201E" }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
    >
        <rect width={width} height={height} fill="white" fill-opacity="0.01" />
        <path
            d="M4.79169 17.1892L1.25 14.0303L2.08194 13.0973L5.60763 16.2421L10.4142 11.589C10.6381 11.3723 10.9371 11.2507 11.2487 11.2497C11.5602 11.2488 11.8601 11.3685 12.0852 11.5837L14.35 13.7489L17.8369 10.0155L18.75 10.8691L15.2618 14.6039C15.1491 14.7245 15.0136 14.8216 14.8632 14.8894C14.7127 14.9573 14.5503 14.9946 14.3853 14.9993C14.2204 15.0039 14.0561 14.9758 13.9021 14.9165C13.7481 14.8572 13.6073 14.768 13.4881 14.6539L11.2528 12.517L6.4615 17.1549C6.23893 17.3704 5.94307 17.4937 5.63333 17.5C5.3236 17.5064 5.02292 17.3954 4.79169 17.1892Z"
            fill={color}
        />
        <path d="M18.75 6.875H16.25L17.5 5L18.75 6.875Z" fill={color} />
        <path
            d="M13.75 2.5H11.25V3.75H13.75V5H11.875V6.25H13.75V7.5H11.25V8.75H13.75C14.0814 8.74955 14.3991 8.61771 14.6334 8.38339C14.8677 8.14907 14.9996 7.83138 15 7.5V3.75C14.9996 3.4186 14.8678 3.10087 14.6335 2.86654C14.3991 2.6322 14.0814 2.50038 13.75 2.5Z"
            fill={color}
        />
        <path
            d="M10 8.75H6.25V6.25C6.25033 5.91858 6.38213 5.60083 6.61648 5.36648C6.85083 5.13213 7.16858 5.00033 7.5 5H8.75V3.75H6.25V2.5H8.75C9.0814 2.50038 9.39913 2.6322 9.63346 2.86654C9.8678 3.10087 9.99962 3.4186 10 3.75V5C9.99962 5.3314 9.8678 5.64913 9.63346 5.88346C9.39913 6.1178 9.0814 6.24962 8.75 6.25H7.5V7.5H10V8.75Z"
            fill={color}
        />
        <path
            d="M3.75 7.5V2.5H2.5V3.125H1.25V4.375H2.5V7.5H1.25V8.75H5V7.5H3.75Z"
            fill={color}
        />
    </svg>
);